module.exports = __webpack_public_path__ + "img/horizontal_4_2_7042.4d8d8910.png";